export default __webpack_public_path__ + "static/media/plusIcon.d4f1b53a.svg";